import { SecondaryMenu } from 'Components/shared/SecondaryMenu';
import { CALLS_SUBMENU_OPTIONS } from 'Constants/routing';
import { useBadgeCounters, useResetMissedCalls } from 'Hooks/badgeCounters';
import { MobXProviderContext, observer } from 'mobx-react';
import { useSoftphoneStore } from 'Modules/softphone/store';
import { useUIStore } from 'Modules/ui/index.store';
import { useIsSecondaryMenuVisible } from 'Modules/ui/secondaryMenu/hooks/useIsSecondaryMenuVisible';
import { getIsSmallScreen } from 'Modules/ui/secondaryMenu/utils';
import React from 'react';
import { Outlet } from 'react-router';
import type { RootStoreProps } from 'Stores/RootStore.types';

export const CallLogs: React.FC = observer(() => {
  const resetMissedCallsBadge = useResetMissedCalls();
  const { missedCallsQuery } = useBadgeCounters();
  const missedCallsCount = missedCallsQuery.data?.data?.count;

  const {
    ui: { isTouchSupported, setDeletePopupDisplay },
    phoneCall: { ActivePhoneCall, incomingPhoneCalls },
  } = React.useContext<RootStoreProps>(MobXProviderContext);
  const isSecondaryMenuVisible = useIsSecondaryMenuVisible();
  const setIsSecondaryMenuOpen = useUIStore(
    (state) => state.setIsSecondaryMenuOpen
  );

  // Use softphone store for dialpad state
  const { setDialpadActive, clearDialpadDigits } = useSoftphoneStore(
    (state) => ({
      setDialpadActive: state.setDialpadActive,
      clearDialpadDigits: state.clearDialpadDigits,
    })
  );

  React.useEffect(() => {
    if (isTouchSupported() && getIsSmallScreen()) {
      setIsSecondaryMenuOpen(true);
    }

    const handleOpenDialpad = () => {
      if (ActivePhoneCall || incomingPhoneCalls.length) return;
      // Clear any previous dial number before opening dialpad
      clearDialpadDigits();
      setDialpadActive(true);
    };

    const handleCloseDialpad = () => {
      // Close dialpad and clear the number when leaving CallLogs page
      setDialpadActive(false);
      clearDialpadDigits();
    };

    if (!getIsSmallScreen()) {
      handleOpenDialpad();
    }

    return () => {
      handleCloseDialpad();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (missedCallsCount > 0) {
      resetMissedCallsBadge.mutate();
    }
  }, []);

  return (
    <div
      className="flex h-full grow isolate"
      onClick={() => setDeletePopupDisplay(false)}
    >
      {isSecondaryMenuVisible && (
        <SecondaryMenu text="Recent calls" options={CALLS_SUBMENU_OPTIONS} />
      )}
      <Outlet />
    </div>
  );
});
